import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner, FormGroup, Label, Input, Alert } from "reactstrap";
import ExistingPlanChoice from './ExistingPlanChoice';

const ActivateTrialModal = ({ open, onClose, organization, onSubmit }) => {
  const [trialPeriod, setTrialPeriod] = useState('14');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [existingPlanAction, setExistingPlanAction] = useState(null);
  const needsChoice = organization?.is_premium && !existingPlanAction;

  useEffect(() => {
    if (open && organization?.is_on_trial) {
      setTrialPeriod(`${organization?.trial_period || 14}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const handleSubmit = async () => {
    if (needsChoice) return;
    try {
      setIsSubmitting(true);
      await onSubmit(organization, parseInt(trialPeriod), existingPlanAction);
      setTrialPeriod('14');
      setExistingPlanAction(null);
      onClose();
    } catch (e) {
      console.error('Error activating trial:', e);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setTrialPeriod('14');
    setExistingPlanAction(null);
    onClose();
  };

  return (
    <Modal isOpen={open} toggle={handleClose} centered>
      <ModalHeader toggle={handleClose}>
        <span style={{ fontSize: "18px", fontWeight: "700" }}>
          Activate Trial
        </span>
      </ModalHeader>
      <ModalBody>
        {organization && (
          <Alert color="info" className="mb-3">
            <div><strong>Organization:</strong> {organization.name || 'N/A'}</div>
            <div><strong>Website:</strong> {organization.website || 'N/A'}</div>
            <div><strong>Type:</strong> {organization.type || 'N/A'}</div>
          </Alert>
        )}

        <ExistingPlanChoice organization={organization} value={existingPlanAction} onChange={setExistingPlanAction} />

        <FormGroup>
          <Label style={{ fontWeight: '500', fontSize: '14px', marginBottom: '10px' }}>
            Select Trial Period
          </Label>
          <div className="d-flex gap-4">
            <div className="form-check">
              <Input
                type="radio"
                id="trial-14"
                name="trialPeriod"
                value="14"
                checked={trialPeriod === '14'}
                onChange={(e) => setTrialPeriod(e.target.value)}
                className="form-check-input"
                style={{ cursor: 'pointer' }}
              />
              <Label
                className="form-check-label"
                htmlFor="trial-14"
                style={{ cursor: 'pointer', fontSize: '14px', fontWeight: '400' }}
              >
                14 Days
              </Label>
            </div>
            <div className="form-check">
              <Input
                type="radio"
                id="trial-30"
                name="trialPeriod"
                value="30"
                checked={trialPeriod === '30'}
                onChange={(e) => setTrialPeriod(e.target.value)}
                className="form-check-input"
                style={{ cursor: 'pointer' }}
              />
              <Label
                className="form-check-label"
                htmlFor="trial-30"
                style={{ cursor: 'pointer', fontSize: '14px', fontWeight: '400' }}
              >
                30 Days
              </Label>
            </div>
          </div>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <button
          className='btn btn-outline-dark'
          onClick={handleClose}
          disabled={isSubmitting}
        >
          Cancel
        </button>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={isSubmitting || needsChoice}
        >
          {isSubmitting ? (
            <Spinner size="sm" color="light" />
          ) : (
            "Activate"
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ActivateTrialModal;
